import { getUserToken, getBackendBaseUrl } from "@/utils/common"
import { Agent as AgentType } from "@/types/admin"
import axios from "axios"

const baseUrl : string = getBackendBaseUrl()

const Agent = () => {

   const getHeaders = () => { 
      return {
         'Authorization': `Bearer ${getUserToken()}`,
         'Content-Type': 'application/json',
      }
   }



   const subAgents = async (scope?: string, startDate?: string, endDate?: string) : Promise<any> => {
      try {
         const params: any = {}
         if (scope) params.scope = scope
         if (startDate) params.start_date = startDate
         if (endDate) params.end_date = endDate
         const response = await axios.get(baseUrl + 'api/agent/sub-agents/list', {params, headers: getHeaders()})
         return response
      } catch (err : any) {
         return err
      }
   }

   const createSubAgent = async (data: AgentType) : Promise<any> => {
      try {
         const response = await axios.put(baseUrl + 'api/agent/sub-agents/create', {name: data.name, email: data.email, phone: data.phone, commission: data.commission, origin: window.location.origin, website_login: data.website_login, is_admin: data.is_admin, active: data.active, password: data.password}, {headers: getHeaders()})
         return response
      } catch (err : any) {
         return err
      }
   }

   const updateSubAgent = async (data: AgentType) : Promise<any> => {
      try {
         const response = await axios.post(baseUrl + 'api/agent/sub-agents/update', {id: data.id, name: data.name, email: data.email, phone: data.phone, commission: data.commission, website_login: data.website_login, is_admin: data.is_admin, active: data.active, password: data.password}, {headers: getHeaders()})
         return response
      } catch (err : any) {
         return err
      }
   }

    const requestRedeemLoyalty = async (form: any, points?: number) : Promise<any> => {
       try {
          const response = await axios.put(baseUrl + 'api/agent/request-redeem/', {
             bankName: form.bankName.value, 
             accountName: form.accountName.value, 
             accountNumber: form.accountNumber.value, 
             countryName: form.countryName.value,
             points: points
          }, {headers: getHeaders()})
          return response
       } catch (err : any) {
          return err
       }
    }

    const loyaltyLogs = async (page: number = 1, limit: number = 10) : Promise<any> => {
      try {
         const response = await axios.get(baseUrl + `api/agent/loyalty-logs?page=${page}&limit=${limit}`, {headers: getHeaders()})
         return response
      } catch (err : any) {
         return err
      }
   }

   const reportsStats = async (scope: string) : Promise<any> => {
      try {
         const response = await axios.get(`${baseUrl}api/agent/reports/stats/${scope}`, {headers: getHeaders()})
         return response
      } catch (err : any) {
         return err
      }
   }

   const removeSubAgent = async (id: number) : Promise<any> => {
      try {
         const response = await axios.delete(baseUrl + 'api/agent/sub-agents/delete', { headers: getHeaders(), data: { id: id } })
         return response
      } catch (err : any) {
         return err
      }
   }

   const allAgentBookings = async () : Promise<any> => {
      try {
         const response = await axios.get(baseUrl + 'api/agent/bookings/list', {params: {}, headers: getHeaders()})
         return response
      } catch (err : any) {
         return err
      }
   }

   const subAgentBookings = async (id: string) : Promise<any> => {
      try {
         const response = await axios.get(`${baseUrl}api/agent/sub-agents/${id}/bookings/list`, {params: {}, headers: getHeaders()})
         return response
      } catch (err : any) {
         return err
      }
   }

   const agentProfile = async () : Promise<any> => {
      try {
         const response = await axios.get(`${baseUrl}api/agent/profile`, {params: {}, headers: getHeaders()})
         return response
      } catch (err : any) {
         return err
      }
   }

   const agentProfileSave = async (data: any, type: 'personal' | 'password') : Promise<any> => {
      let response
      try {
         if (type == 'personal') {
            response = await axios.post(baseUrl + 'api/agent/profile', {
               name: data.fullName,
               phone: data.phone,
               commission: data.commission,
               company: data.company,
               email: data.email,
               photo: data.photo,
               cr_number: data.crNumber,
               vat_number: data.vatNumber,
               bank_name: data.bankName,
               bank_account_name: data.bankAccountName,
               bank_account_number: data.bankAccountNumber,
               bank_iban: data.bankIban,
               bank_swift: data.bankSwift,
               country: data.country
            }, {headers: getHeaders()})
         } else {
            response = await axios.post(baseUrl + 'api/agent/password', {currentPassword: data.current, newPassword: data.new, passwordConfirmation: data.confirmNew}, {headers: getHeaders()})
         }

         return response
      } catch (err : any) {
         return err
      }
   }

   return {
      subAgents,
      createSubAgent,
      updateSubAgent,
      removeSubAgent,
      allAgentBookings,
      subAgentBookings,
      agentProfile,
      agentProfileSave,
      requestRedeemLoyalty,
      loyaltyLogs,
      reportsStats
   }
}

export default Agent